<template>
  <AppHeaderDropdown right>
    <template slot="header">
      <span class="d-md-down-none" v-b-tooltip.hover :title="user.USER_NAME">{{fullName}}</span>
      <avatar
        :src="user.USER_PROFILE_PIC_URL"
        :username="fullName"
        :size="35"
        class="img-avatar align-middle"
        inline />
      <!-- <img
        v-if="user.USER_PROFILE_PIC_URL"
        :src="user.USER_PROFILE_PIC_URL"
        class="img-avatar" /> -->
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item @click="viewProfile()"><i class="icon-user" /> Profile</b-dropdown-item>
      <b-dropdown-item @click="changePassword()"><i class="icon-key" /> Change Password</b-dropdown-item>
      <b-dropdown-item @click="logout()"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import Avatar from 'vue-avatar'
import { UserProfilesModal } from '@/components/modals/'
import { auth, server } from '@/services/'
import { mapState } from 'vuex'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown,
    Avatar
  },
  created () {
    if (_.isEmpty(this.user)) {
      let userFromStorage = auth.getUser()
      this.$store.commit('userProfile/setUser', userFromStorage)
    }
  },
  computed: {
    fullName() {
      return `${this.user.USER_PROFILE_FIRST_NAME} ${this.user.USER_PROFILE_LAST_NAME}`
    },
    ...mapState('userProfile', [
      'user'
    ])
  },
  methods: {
    logout () {
      auth.redirect()
    },
    changePassword () {
      let token = auth.getToken()
      let encryptedToken = auth.encryptToken(token)
      localStorage.clear()
      window.location.href = `${process.env.VUE_APP_CHANGE_PASSWORD_URL}?hash=${encryptedToken}&appId=USSE-1`
    },
    viewProfile () {
      server.get('/getUP_byUACode/jwtCode').then(
        resp => this.$modal.show(UserProfilesModal, { caller: 'header', model: resp.data.msgContent.data[0] }, { height: 'auto' })
      )
    }
  }
}
</script>
